import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';
import { addOnSchema } from './add-on';
import { mapUpdateFrequencySchema } from './map-update-frequency.schema';

export const accountProductSchema = z.object({
  active: z.boolean().nullable(),
  addons: z.array(addOnSchema).nullable().optional(),
  applicationId: z.number().nullable(),
  assignedLicenses: z.number(),
  availableLicenses: z.number(),
  expirationDate: coercedDate.nullable(),
  numberOfLicenses: z.number().nullable(),
  productId: z.number().nullable(),
  productName: z.string().nullable(),
  purchaseDate: coercedDate.nullable(),
  mapUpdateFrequency: mapUpdateFrequencySchema.optional(),
});

export type AccountProduct = z.infer<typeof accountProductSchema>;
